<div class="simulator">
	<section class="simulator__head">
		<!-- <h2>
			Elige un monto de hasta <span>${{ authorizedAmount | number }}</span>
		</h2> -->
	</section>
	<section class="simulator__range-input">
		<cmv-range-input
			[maximumAmount]="authorizedAmount"
			[mininumAmount]="minimumAmount"
			[amount]="montoLocal"
			jump="100"
			[enableQuickSelection]="true"
			[quickAmounts]="[10000, 25000, 50000]"
			(rangeAmountChange)="calculaPago($event, plazoLocal)"></cmv-range-input>
	</section>
	<section class="simulator__period-selector">
		<cmv-plazo-selector
			[valInput]="plazoLocal"
			[maxTerm]="maxTerm"
			(plazoChange)="calculaPago(montoLocal, $event)"></cmv-plazo-selector>
	</section>
	<section class="simulator__result">
		<p class="simulator__result-text">
			Tu pago mensual sería de
			<span *ngIf="!cargandoPago && !simulationError">{{ pagoMensual | currency }}</span>
			<span *ngIf="!cargandoPago && simulationError">Error</span>
			<span *ngIf="cargandoPago" class="spinner-border spinner-border-sm text-secondary" role="status"></span>
		</p>
	</section>
	<ng-content></ng-content>
</div>
